import React from "react";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";


interface IframeworkCanvasAutoplayForMobile {
    data: {}

}

export const frameworkCanvasAutoplayForMobile: IframeworkCanvasAutoplayForMobile = {

    data: {
        "COMPONENTS": [
            //{
            //    "name": "desk_autoplay_base",
            //    "image": "desk_autoplay_base.png",
            //    "type": "Image",
            //    "class": "",
            //    "layout": true,
            //    "uimode": "mobile",
            //    "visible": true,
            //    "width": 1251,
            //    "height": 800,
            //    "anchor": [0, 0],
            //    "x": 335,
            //    "y": 50,
            //},
            {
                "name": "desk_autoplay_base_mobile",
                "type": "Graphic",
                "shape": "rectangle",
                "layout": true,
                "uimode": "mobile",
                "visible": true,
                "alpha": 0.91,
                "color": "0x000000",
                "x": 0,
                "y": 0,
                "width": 1920,
                "height": 1080,

            },
            {
                "name": "desk_autoplay_base_mobile_portrait",
                "type": "Graphic",
                "shape": "rectangle",
                "layout": true,
                "uimode": "mobile",
                "visible": true,
                "alpha": 0.91,
                "color": "0x000000",
                "x": 0,
                "y": 0,
                "width": 1080,
                "height": 1920,

            },

            /* {
                "name": "lossLimitBg",
                "type": "Graphic",
                "shape": "rectangle",
                "layout": true,
                "uimode": "mobile",
                "visible": true,
                "alpha": 1,
                "color": "0x131313",
                "x": 40,
                "y": 180,
                "width": 1000,
                "height": 300,

            },
            {
                "name": "winLimitBg",
                "type": "Graphic",
                "shape": "rectangle",
                "layout": true,
                "uimode": "mobile",
                "visible": true,
                "alpha": 1,
                "color": "0x131313",
                "x": 40,
                "y": 580,
                "width": 1000,
                "height": 300,

            },
            {
                "name": "singleWinBG",
                "type": "Graphic",
                "shape": "rectangle",
                "layout": true,
                "uimode": "mobile",
                "visible": true,
                "alpha": 1,
                "color": "0x131313",
                "x": 40,
                "y": 980,
                "width": 1000,
                "height": 300,

            }, */
            /*      {
                     "id": "loss_limit_label",
                     "name": "autoplay_losslimitlbl",
                     "type": "Text",
                     "x": 115,
                     "y": 110,
                     "width": 350,
                     "visible": true,
                     "layout": true,
                     "uiMode": "mobile",
                     "text": "LossLimit_txt",
                     "scaleToFit": true,
                     "anchor": [0, 0],
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 26,
                         fontStyle: 'normal',
                         fill: ['#848484'],
                     },
                 },
     
                 {
                     "id": "text_1",
                     "name": "funText1",
                     "type": "Text",
                     "x": 1315,
                     "y": 114,
                     "layout": true,
                     "uiMode": "mobile",
                     "visible": true,
                     "text": "",
                     "width": 200,
                     "scaleToFit": true,
                     "anchor": [0.5, 0.5],
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 30,
                         fontWeight: 'bold',
                         fill: ['#FEDE00'],
                     },
                     "parentLayer": "specialAnimationLayer",
                 },
     
                 {
                     "id": "sliderDot_inputBoxText",
                     "name": "sliderDot_inputBoxText",
                     "type": "Text",
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 293,
                     "y": 127,
                     "width": 151,
                     "height": 41,
                     "visible": true,
                     "text": "",
                     "scaleToFit": true,
                     "anchor": [0.5, 0.5],
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
     
                         fill: '#ffffff',
                     },
                 },
     
                 {
                     "id": "LossLimitBtn1",
                     "name": "LossLimitBtn1",
                     "type": objectTypes.Sprite,
                     "interactive": true,
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 235,
                     "y": 212,
                     "width": 230,
                     "height": 83,
                     "text": "option1",
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 35,
                         fontStyle: 'normal',
     
                         fill: ['#ffffff'],
                     },
                     "anchor": [0.5, 0.5],
                     "visible": true,
                     "buttonMode": true,
                     "buttonState": {
                         up: 'land_autoplay_btn_deselected.png',
                         out: 'land_autoplay_btn_deselected.png',
                         down: 'land_autoplay_btn_deselected.png',
                         disable: 'land_autoplay_btn_deselected.png',
                         enable: 'land_autoplay_btn_deselected.png',
                         hover: 'land_autoplay_btn_deselected.png'
                     },
                     "hitareaVisible": false,
                     "shapeVisible": false,
                     "shape": {}
                 },
     
                 {
                     "id": "LossLimitBtn2",
                     "name": "LossLimitBtn2",
                     "type": objectTypes.Sprite,
                     "interactive": false,
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 502,
                     "y": 212,
                     "width": 230,
                     "height": 83,
                     "text": "option2",
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
                         fontStyle: 'normal',
     
                         fill: ['#ffffff'],
                     },
                     "anchor": [0.5, 0.5],
                     "visible": true,
                     "buttonMode": true,
                     "buttonState": {
                         up: 'land_autoplay_btn_deselected.png',
                         out: 'land_autoplay_btn_deselected.png',
                         down: 'land_autoplay_btn_deselected.png',
                         disable: 'land_autoplay_btn_deselected.png',
                         enable: 'land_autoplay_btn_deselected.png',
                         hover: 'land_autoplay_btn_deselected.png'
                     },
                     "hitareaVisible": false,
                     "shapeVisible": false,
                     "shape": {}
                 },
     
                 {
                     "id": "LossLimitBtn3",
                     "name": "LossLimitBtn3",
                     "type": objectTypes.Sprite,
                     "interactive": true,
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 769,
                     "y": 212,
                     "width": 230,
                     "height": 83,
                     "text": "option3",
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
                         fontStyle: 'normal',
     
                         fill: ['#ffffff'],
                     },
                     "anchor": [0.5, 0.5],
                     "visible": true,
                     "buttonMode": true,
                     "buttonState": {
                         up: 'land_autoplay_btn_deselected.png',
                         out: 'land_autoplay_btn_deselected.png',
                         down: 'land_autoplay_btn_deselected.png',
                         disable: 'land_autoplay_btn_deselected.png',
                         enable: 'land_autoplay_btn_deselected.png',
                         hover: 'land_autoplay_btn_deselected.png'
                     },
                     "hitareaVisible": false,
                     "shapeVisible": false,
                     "shape": {}
                 },
     
                 {
                     "id": "LossLimitBtn4",
                     "name": "LossLimitBtn4",
                     "type": objectTypes.Sprite,
                     "interactive": true,
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 1036,
                     "y": 212,
                     "width": 230,
                     "height": 83,
                     "text": "option4",
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
                         fontStyle: 'normal',
     
                         fill: ['#ffffff'],
                     },
                     "anchor": [0.5, 0.5],
                     "visible": true,
                     "buttonMode": true,
                     "buttonState": {
                         up: 'land_autoplay_btn_deselected.png',
                         out: 'land_autoplay_btn_deselected.png',
                         down: 'land_autoplay_btn_deselected.png',
                         disable: 'land_autoplay_btn_deselected.png',
                         enable: 'land_autoplay_btn_deselected.png',
                         hover: 'land_autoplay_btn_deselected.png'
                     },
                     "hitareaVisible": false,
                     "shapeVisible": false,
                     "shape": {}
                 },
                 {
                     "id": "LossLimitBtn5",
                     "name": "LossLimitBtn5",
                     "type": objectTypes.Sprite,
                     "interactive": true,
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 1303,
                     "y": 212,
                     "width": 230,
                     "height": 83,
                     "text": "option5",
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
                         fontStyle: 'normal',
     
                         fill: ['#ffffff'],
                     },
                     "anchor": [0.5, 0.5],
                     "visible": true,
                     "buttonMode": true,
                     "buttonState": {
                         up: 'land_autoplay_btn_deselected.png',
                         out: 'land_autoplay_btn_deselected.png',
                         down: 'land_autoplay_btn_deselected.png',
                         disable: 'land_autoplay_btn_deselected.png',
                         enable: 'land_autoplay_btn_deselected.png',
                         hover: 'land_autoplay_btn_deselected.png'
                     },
                     "hitareaVisible": false,
                     "shapeVisible": false,
                     "shape": {}
                 },
     
                 {
                     "id": "lossLimit__Container",
                     "name": "lossLimit__Container",
                     "type": "Container",
                     "x": -400,
                     "y": -160,
                     "uimode": "mobile",
                     "layout": true,
                     "visible": true,
                     child: [
     
     
     
     
                     ]
                 }, */
            ///Loss limit -------------------------
            /*      {
                     "id": "loss_limit_label",
                     "name": "autoplay_winLimitlbl",
                     "type": "Text",
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 115,
                     "y": 320,
                     "width": 300,
                     "visible": true,
                     "text": "winLimit_txt",
                     "scaleToFit": true,
                     "anchor": [0, 0],
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 22,
                         fontStyle: 'normal',
                         fill: ['#848484'],
                     },
                 },
                 {
                     "id": "text_2",
                     "name": "funText2",
                     "type": "Text",
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 1315,
                     "y": 324,
                     "visible": true,
                     "text": "",
                     "width": 200,
                     "scaleToFit": true,
                     "anchor": [0.5, 0.5],
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 30,
                         fontWeight: 'bold',
                         fill: ['#FEDE00'],
                     },
                     "parentLayer": "specialAnimationLayer",
                 },
     
     
                 {
                     "id": "sliderDot_2_inputBoxText",
                     "name": "sliderDot_2_inputBoxText",
                     "type": "Text",
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 293,
                     "y": 327,
                     "width": 151,
                     "height": 41,
                     "visible": true,
                     "text": "",
                     "scaleToFit": true,
                     "anchor": [0.5, 0.5],
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
     
                         fill: '#ffffff',
                     },
                 },
     
                 {
                     "id": "winLimitBtn1",
                     "name": "winLimitBtn1",
                     "type": objectTypes.Sprite,
                     "interactive": false,
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 235,
                     "y": 422,
                     "width": 230,
                     "height": 83,
                     "text": "option1",
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
                         fontStyle: 'normal',
     
                         fill: ['#ffffff'],
                     },
                     "anchor": [0.5, 0.5],
                     "visible": true,
                     "buttonMode": true,
                     "buttonState": {
                         up: 'land_autoplay_btn_deselected.png',
                         out: 'land_autoplay_btn_deselected.png',
                         down: 'land_autoplay_btn_deselected.png',
                         disable: 'land_autoplay_btn_deselected.png',
                         enable: 'land_autoplay_btn_deselected.png',
                         hover: 'land_autoplay_btn_deselected.png'
                     },
                     "hitareaVisible": false,
                     "shapeVisible": false,
                     "shape": {}
                 },
                 {
                     "id": "winLimitBtn2",
                     "name": "winLimitBtn2",
                     "type": objectTypes.Sprite,
                     "interactive": false,
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 502,
                     "y": 422,
                     "width": 230,
                     "height": 83,
                     "text": "option2",
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
                         fontStyle: 'normal',
     
                         fill: ['#ffffff'],
                     },
                     "anchor": [0.5, 0.5],
                     "visible": true,
                     "buttonMode": true,
                     "buttonState": {
                         up: 'land_autoplay_btn_deselected.png',
                         out: 'land_autoplay_btn_deselected.png',
                         down: 'land_autoplay_btn_deselected.png',
                         disable: 'land_autoplay_btn_deselected.png',
                         enable: 'land_autoplay_btn_deselected.png',
                         hover: 'land_autoplay_btn_deselected.png'
                     },
                     "hitareaVisible": false,
                     "shapeVisible": false,
                     "shape": {}
                 },
                 {
                     "id": "winLimitBtn3",
                     "name": "winLimitBtn3",
                     "type": objectTypes.Sprite,
                     "interactive": true,
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 769,
                     "y": 422,
                     "width": 230,
                     "height": 83,
                     "text": "option3",
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
                         fontStyle: 'normal',
     
                         fill: ['#ffffff'],
                     },
                     "anchor": [0.5, 0.5],
                     "visible": true,
                     "buttonMode": true,
                     "buttonState": {
                         up: 'land_autoplay_btn_deselected.png',
                         out: 'land_autoplay_btn_deselected.png',
                         down: 'land_autoplay_btn_deselected.png',
                         disable: 'land_autoplay_btn_deselected.png',
                         enable: 'land_autoplay_btn_deselected.png',
                         hover: 'land_autoplay_btn_deselected.png'
                     },
                     "hitareaVisible": false,
                     "shapeVisible": false,
                     "shape": {}
                 },
                 {
                     "id": "winLimitBtn4",
                     "name": "winLimitBtn4",
                     "type": objectTypes.Sprite,
                     "interactive": true,
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 1036,
                     "y": 422,
                     "width": 230,
                     "height": 83,
                     "text": "option4",
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
                         fontStyle: 'normal',
     
                         fill: ['#ffffff'],
                     },
                     "anchor": [0.5, 0.5],
                     "visible": true,
                     "buttonMode": true,
                     "buttonState": {
                         up: 'land_autoplay_btn_deselected.png',
                         out: 'land_autoplay_btn_deselected.png',
                         down: 'land_autoplay_btn_deselected.png',
                         disable: 'land_autoplay_btn_deselected.png',
                         enable: 'land_autoplay_btn_deselected.png',
                         hover: 'land_autoplay_btn_deselected.png'
                     },
                     "hitareaVisible": false,
                     "shapeVisible": false,
                     "shape": {}
                 },
                 {
                     "id": "winLimitBtn5",
                     "name": "winLimitBtn5",
                     "type": objectTypes.Sprite,
                     "interactive": true,
                     "layout": true,
                     "uiMode": "mobile",
                     "x": 1303,
                     "y": 422,
                     "width": 230,
                     "height": 83,
                     "text": "option5",
                     "textStyle": {
                         fontFamily: 'Oswald-Light',
                         fontSize: 24,
                         fontStyle: 'normal',
     
                         fill: ['#ffffff'],
                     },
                     "anchor": [0.5, 0.5],
                     "visible": true,
                     "buttonMode": true,
                     "buttonState": {
                         up: 'land_autoplay_btn_deselected.png',
                         out: 'land_autoplay_btn_deselected.png',
                         down: 'land_autoplay_btn_deselected.png',
                         disable: 'land_autoplay_btn_deselected.png',
                         enable: 'land_autoplay_btn_deselected.png',
                         hover: 'land_autoplay_btn_deselected.png'
                     },
                     "hitareaVisible": false,
                     "shapeVisible": false,
                     "shape": {}
                 }, */

            /* {
                "id": "winLimit__Container",
                "name": "winLimit__Container",
                "type": "Container",
                "x": -400,
                "y": 50,
                "layout": true,
                "uimode": "mobile",
                "visible": true,
                child: [

                    {
                        "id": "loss_limit_label",
                        "name": "autoplay_winLimitlbl",
                        "type": "Text",
                        "x": 515,
                        "y": 270,
                        "width": 300,
                        "visible": true,
                        "text": "winLimit_txt",
                        "scaleToFit": true,
                        "anchor": [0, 0],
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 22,
                            fontStyle: 'normal',
                            fill: ['#848484'],
                        },
                    },
                    {
                        "id": "text_2",
                        "name": "funText2",
                        "type": "Text",
                        "x": 1715,
                        "y": 274,
                        "visible": true,
                        "text": "FUN0.00",
                        "width": 100,
                        "scaleToFit": true,
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 30,
                            fontWeight: 'bold',
                            fill: ['#FEDE00'],
                        },
                        "parentLayer": "specialAnimationLayer",
                    },
                    // {
                    //     "name": "valueFramewinLimit",
                    //     "image": "value_txt_frame.png",
                    //     "type": "Image",
                    //     "class": "",
                    //     "layout": false,
                    //     "uimode": "desktop",
                    //     "visible": true,
                    //     "width": 151,
                    //     "height": 41,
                    //     "anchor": [0, 0],
                    //     "x": 620,
                    //     "y": 265,
                    // },

                    // {
                    //     "name": "inputBox_2",
                    //     "type": "Graphic",
                    //     "shape": "rectangle",
                    //     "visible": true,
                    //     "buttonMode": true,
                    //     "interactive": false,
                    //     "alpha": 0.1,
                    //     "color": "0x131313",
                    //     "x": 620,
                    //     "y": 265,
                    //     "width": 151,
                    //     "height": 41,

                    // },

                    {
                        "id": "sliderDot_2_inputBoxText",
                        "name": "sliderDot_2_inputBoxText",
                        "type": "Text",
                        "x": 693,
                        "y": 287,
                        "width": 151,
                        "height": 41,
                        "visible": true,
                        "text": "",
                        "scaleToFit": true,
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 24,

                            fill: '#ffffff',
                        },
                    },

                    {
                        "id": "winLimitBtn1",
                        "name": "winLimitBtn1",
                        "type": objectTypes.Sprite,
                        "interactive": false,
                        "x": 635,
                        "y": 372,
                        "width": 230,
                        "height": 83,
                        "text": "option1",
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 24,
                            fontStyle: 'normal',

                            fill: ['#ffffff'],
                        },
                        "anchor": [0.5, 0.5],
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'land_autoplay_btn_deselected.png',
                            out: 'land_autoplay_btn_deselected.png',
                            down: 'land_autoplay_btn_deselected.png',
                            disable: 'land_autoplay_btn_deselected.png',
                            enable: 'land_autoplay_btn_deselected.png',
                            hover: 'land_autoplay_btn_deselected.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                    {
                        "id": "winLimitBtn2",
                        "name": "winLimitBtn2",
                        "type": objectTypes.Sprite,
                        "interactive": false,
                        "x": 902,
                        "y": 372,
                        "width": 230,
                        "height": 83,
                        "text": "option2",
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 24,
                            fontStyle: 'normal',

                            fill: ['#ffffff'],
                        },
                        "anchor": [0.5, 0.5],
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'land_autoplay_btn_deselected.png',
                            out: 'land_autoplay_btn_deselected.png',
                            down: 'land_autoplay_btn_deselected.png',
                            disable: 'land_autoplay_btn_deselected.png',
                            enable: 'land_autoplay_btn_deselected.png',
                            hover: 'land_autoplay_btn_deselected.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                    {
                        "id": "winLimitBtn3",
                        "name": "winLimitBtn3",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        "x": 1169,
                        "y": 372,
                        "width": 230,
                        "height": 83,
                        "text": "option3",
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 24,
                            fontStyle: 'normal',

                            fill: ['#ffffff'],
                        },
                        "anchor": [0.5, 0.5],
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'land_autoplay_btn_deselected.png',
                            out: 'land_autoplay_btn_deselected.png',
                            down: 'land_autoplay_btn_deselected.png',
                            disable: 'land_autoplay_btn_deselected.png',
                            enable: 'land_autoplay_btn_deselected.png',
                            hover: 'land_autoplay_btn_deselected.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                    {
                        "id": "winLimitBtn4",
                        "name": "winLimitBtn4",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        "x": 1436,
                        "y": 372,
                        "width": 230,
                        "height": 83,
                        "text": "option4",
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 24,
                            fontStyle: 'normal',

                            fill: ['#ffffff'],
                        },
                        "anchor": [0.5, 0.5],
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'land_autoplay_btn_deselected.png',
                            out: 'land_autoplay_btn_deselected.png',
                            down: 'land_autoplay_btn_deselected.png',
                            disable: 'land_autoplay_btn_deselected.png',
                            enable: 'land_autoplay_btn_deselected.png',
                            hover: 'land_autoplay_btn_deselected.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                    {
                        "id": "winLimitBtn5",
                        "name": "winLimitBtn5",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        "x": 1703,
                        "y": 372,
                        "width": 230,
                        "height": 83,
                        "text": "option5",
                        "textStyle": {
                            fontFamily: 'Oswald-Light',
                            fontSize: 24,
                            fontStyle: 'normal',

                            fill: ['#ffffff'],
                        },
                        "anchor": [0.5, 0.5],
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'land_autoplay_btn_deselected.png',
                            out: 'land_autoplay_btn_deselected.png',
                            down: 'land_autoplay_btn_deselected.png',
                            disable: 'land_autoplay_btn_deselected.png',
                            enable: 'land_autoplay_btn_deselected.png',
                            hover: 'land_autoplay_btn_deselected.png'
                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                ]
            }, */
            //////////////////// singlewinLimit ----------------------

            /*       {
                      "id": "loss_limit_label",
                      "name": "autoplay_singleWinLimitlbl",
                      "type": "Text",
                      "layout": true,
                      "uiMode": "mobile",
                      "x": 115,
                      "y": 570,
                      "width": 300,
                      "visible": true,
                      "text": "singleWinLimit_txt",
                      "scaleToFit": true,
                      "anchor": [0, 0],
                      "textStyle": {
                          fontFamily: 'Oswald-Light',
                          fontSize: 22,
                          fontStyle: 'normal',
                          fill: ['#848484'],
                      },
                  },
                  {
                      "id": "text_3",
                      "name": "funText3",
                      "type": "Text",
                      "layout": true,
                      "uiMode": "mobile",
                      "x": 1315,
                      "y": 574,
                      "visible": true,
                      "text": "",
                      "width": 200,
                      "scaleToFit": true,
                      "anchor": [0.5, 0.5],
                      "textStyle": {
                          fontFamily: 'Oswald-Light',
                          fontSize: 30,
                          fontWeight: 'bold',
                          fill: ['#FEDE00'],
                      },
                      "parentLayer": "specialAnimationLayer",
                  },
      
                  {
                      "id": "sliderDot_3_inputBoxText",
                      "name": "sliderDot_3_inputBoxText",
                      "type": "Text",
                      "layout": true,
                      "uiMode": "mobile",
                      "x": 293,
                      "y": 587,
                      "width": 151,
                      "height": 41,
                      "visible": true,
                      "text": "",
                      "scaleToFit": true,
                      "anchor": [0.5, 0.5],
                      "textStyle": {
                          fontFamily: 'Oswald-Light',
                          fontSize: 24,
      
                          fill: '#ffffff',
                      },
                  },
                  {
                      "id": "singleWinLimitBtn1",
                      "name": "singleWinLimitBtn1",
                      "type": objectTypes.Sprite,
                      "interactive": false,
                      "layout": true,
                      "uiMode": "mobile",
                      "x": 235,
                      "y": 672,
                      "width": 230,
                      "height": 83,
                      "text": "option1",
                      "textStyle": {
                          fontFamily: 'Oswald-Light',
                          fontSize: 24,
                          fontStyle: 'normal',
      
                          fill: ['#ffffff'],
                      },
                      "anchor": [0.5, 0.5],
                      "visible": true,
                      "buttonMode": true,
                      "buttonState": {
                          up: 'land_autoplay_btn_deselected.png',
                          out: 'land_autoplay_btn_deselected.png',
                          down: 'land_autoplay_btn_deselected.png',
                          disable: 'land_autoplay_btn_deselected.png',
                          enable: 'land_autoplay_btn_deselected.png',
                          hover: 'land_autoplay_btn_deselected.png'
                      },
                      "hitareaVisible": false,
                      "shapeVisible": false,
                      "shape": {}
                  },
                  {
                      "id": "singleWinLimitBtn2",
                      "name": "singleWinLimitBtn2",
                      "type": objectTypes.Sprite,
                      "interactive": false,
                      "layout": true,
                      "uiMode": "mobile",
                      "x": 502,
                      "y": 672,
                      "width": 230,
                      "height": 83,
                      "text": "option2",
                      "textStyle": {
                          fontFamily: 'Oswald-Light',
                          fontSize: 24,
                          fontStyle: 'normal',
      
                          fill: ['#ffffff'],
                      },
                      "anchor": [0.5, 0.5],
                      "visible": true,
                      "buttonMode": true,
                      "buttonState": {
                          up: 'land_autoplay_btn_deselected.png',
                          out: 'land_autoplay_btn_deselected.png',
                          down: 'land_autoplay_btn_deselected.png',
                          disable: 'land_autoplay_btn_deselected.png',
                          enable: 'land_autoplay_btn_deselected.png',
                          hover: 'land_autoplay_btn_deselected.png'
                      },
                      "hitareaVisible": false,
                      "shapeVisible": false,
                      "shape": {}
                  },
                  {
                      "id": "singleWinLimitBtn3",
                      "name": "singleWinLimitBtn3",
                      "type": objectTypes.Sprite,
                      "interactive": true,
                      "layout": true,
                      "uiMode": "mobile",
                      "x": 769,
                      "y": 672,
                      "width": 230,
                      "height": 83,
                      "text": "option3",
                      "textStyle": {
                          fontFamily: 'Oswald-Light',
                          fontSize: 24,
                          fontStyle: 'normal',
      
                          fill: ['#ffffff'],
                      },
                      "anchor": [0.5, 0.5],
                      "visible": true,
                      "buttonMode": true,
                      "buttonState": {
                          up: 'land_autoplay_btn_deselected.png',
                          out: 'land_autoplay_btn_deselected.png',
                          down: 'land_autoplay_btn_deselected.png',
                          disable: 'land_autoplay_btn_deselected.png',
                          enable: 'land_autoplay_btn_deselected.png',
                          hover: 'land_autoplay_btn_deselected.png'
                      },
                      "hitareaVisible": false,
                      "shapeVisible": false,
                      "shape": {}
                  },
                  {
                      "id": "singleWinLimitBtn4",
                      "name": "singleWinLimitBtn4",
                      "type": objectTypes.Sprite,
                      "interactive": true,
                      "layout": true,
                      "uiMode": "mobile",
                      "x": 1036,
                      "y": 672,
                      "width": 230,
                      "height": 83,
                      "text": "option4",
                      "textStyle": {
                          fontFamily: 'Oswald-Light',
                          fontSize: 24,
                          fontStyle: 'normal',
      
                          fill: ['#ffffff'],
                      },
                      "anchor": [0.5, 0.5],
                      "visible": true,
                      "buttonMode": true,
                      "buttonState": {
                          up: 'land_autoplay_btn_deselected.png',
                          out: 'land_autoplay_btn_deselected.png',
                          down: 'land_autoplay_btn_deselected.png',
                          disable: 'land_autoplay_btn_deselected.png',
                          enable: 'land_autoplay_btn_deselected.png',
                          hover: 'land_autoplay_btn_deselected.png'
                      },
                      "hitareaVisible": false,
                      "shapeVisible": false,
                      "shape": {}
                  },
                  {
                      "id": "singleWinLimitBtn5",
                      "name": "singleWinLimitBtn5",
                      "type": objectTypes.Sprite,
                      "interactive": true,
                      "layout": true,
                      "uiMode": "mobile",
                      "x": 1303,
                      "y": 672,
                      "width": 230,
                      "height": 83,
                      "text": "option5",
                      "textStyle": {
                          fontFamily: 'Oswald-Light',
                          fontSize: 24,
                          fontStyle: 'normal',
      
                          fill: ['#ffffff'],
                      },
                      "anchor": [0.5, 0.5],
                      "visible": true,
                      "buttonMode": true,
                      "buttonState": {
                          up: 'land_autoplay_btn_deselected.png',
                          out: 'land_autoplay_btn_deselected.png',
                          down: 'land_autoplay_btn_deselected.png',
                          disable: 'land_autoplay_btn_deselected.png',
                          enable: 'land_autoplay_btn_deselected.png',
                          hover: 'land_autoplay_btn_deselected.png'
                      },
                      "hitareaVisible": false,
                      "shapeVisible": false,
                      "shape": {}
                  }, */


            /*  {
                 "id": "singleWinLimit__Container",
                 "name": "singleWinLimit__Container",
                 "type": "Container",
                 "x": -400,
                 "y": 300,
                 "layout": true,
                 "uimode": "mobile",
                 "visible": true,
                 child: [
                    
 
                     {
                         "id": "loss_limit_label",
                         "name": "autoplay_singleWinLimitlbl",
                         "type": "Text",
                         "uiMode": "desktop",
                         "layout": false,
                         "x": 515,
                         "y": 270,
                         "width": 300,
                         "visible": true,
                         "text": "singleWinLimit_txt",
                         "scaleToFit": true,
                         "anchor": [0, 0],
                         "textStyle": {
                             fontFamily: 'Oswald-Light',
                             fontSize: 22,
                             fontStyle: 'normal',
                             fill: ['#848484'],
                         },
                     },
                     {
                         "id": "text_3",
                         "name": "funText3",
                         "type": "Text",
                         "uiMode": "desktop",
                         "layout": false,
                         "x": 1715,
                         "y": 274,
                         "visible": true,
                         "text": "FUN0.00",
                         "width": 100,
                         "scaleToFit": true,
                         "anchor": [0.5, 0.5],
                         "textStyle": {
                             fontFamily: 'Oswald-Light',
                             fontSize: 30,
                             fontWeight: 'bold',
                             fill: ['#FEDE00'],
                         },
                         "parentLayer": "specialAnimationLayer",
                     },
                    
                     {
                         "id": "sliderDot_3_inputBoxText",
                         "name": "sliderDot_3_inputBoxText",
                         "type": "Text",
                         "uiMode": "desktop",
                         "layout": false,
                         "x": 693,
                         "y": 287,
                         "width": 151,
                         "height": 41,
                         "visible": true,
                         "text": "",
                         "scaleToFit": true,
                         "anchor": [0.5, 0.5],
                         "textStyle": {
                             fontFamily: 'Oswald-Light',
                             fontSize: 24,
 
                             fill: '#ffffff',
                         },
                     },
                     {
                         "id": "singleWinLimitBtn1",
                         "name": "singleWinLimitBtn1",
                         "type": objectTypes.Sprite,
                         "interactive": false,
                         "uiMode": "desktop",
                         "layout": false,
                         "x": 635,
                         "y": 372,
                         "width": 230,
                         "height": 83,
                         "text": "option1",
                         "textStyle": {
                             fontFamily: 'Oswald-Light',
                             fontSize: 24,
                             fontStyle: 'normal',
 
                             fill: ['#ffffff'],
                         },
                         "anchor": [0.5, 0.5],
                         "visible": true,
                         "buttonMode": true,
                         "buttonState": {
                             up: 'land_autoplay_btn_deselected.png',
                             out: 'land_autoplay_btn_deselected.png',
                             down: 'land_autoplay_btn_deselected.png',
                             disable: 'land_autoplay_btn_deselected.png',
                             enable: 'land_autoplay_btn_deselected.png',
                             hover: 'land_autoplay_btn_deselected.png'
                         },
                         "hitareaVisible": false,
                         "shapeVisible": false,
                         "shape": {}
                     },
                     {
                         "id": "singleWinLimitBtn2",
                         "name": "singleWinLimitBtn2",
                         "type": objectTypes.Sprite,
                         "interactive": false,
                         "uiMode": "desktop",
                         "layout": false,
                         "x": 902,
                         "y": 372,
                         "width": 230,
                         "height": 83,
                         "text": "option2",
                         "textStyle": {
                             fontFamily: 'Oswald-Light',
                             fontSize: 24,
                             fontStyle: 'normal',
 
                             fill: ['#ffffff'],
                         },
                         "anchor": [0.5, 0.5],
                         "visible": true,
                         "buttonMode": true,
                         "buttonState": {
                             up: 'land_autoplay_btn_deselected.png',
                             out: 'land_autoplay_btn_deselected.png',
                             down: 'land_autoplay_btn_deselected.png',
                             disable: 'land_autoplay_btn_deselected.png',
                             enable: 'land_autoplay_btn_deselected.png',
                             hover: 'land_autoplay_btn_deselected.png'
                         },
                         "hitareaVisible": false,
                         "shapeVisible": false,
                         "shape": {}
                     },
                     {
                         "id": "singleWinLimitBtn3",
                         "name": "singleWinLimitBtn3",
                         "type": objectTypes.Sprite,
                         "interactive": true,
                         "uiMode": "desktop",
                         "layout": false,
                         "x": 1169,
                         "y": 372,
                         "width": 230,
                         "height": 83,
                         "text": "option3",
                         "textStyle": {
                             fontFamily: 'Oswald-Light',
                             fontSize: 24,
                             fontStyle: 'normal',
 
                             fill: ['#ffffff'],
                         },
                         "anchor": [0.5, 0.5],
                         "visible": true,
                         "buttonMode": true,
                         "buttonState": {
                             up: 'land_autoplay_btn_deselected.png',
                             out: 'land_autoplay_btn_deselected.png',
                             down: 'land_autoplay_btn_deselected.png',
                             disable: 'land_autoplay_btn_deselected.png',
                             enable: 'land_autoplay_btn_deselected.png',
                             hover: 'land_autoplay_btn_deselected.png'
                         },
                         "hitareaVisible": false,
                         "shapeVisible": false,
                         "shape": {}
                     },
                     {
                         "id": "singleWinLimitBtn4",
                         "name": "singleWinLimitBtn4",
                         "type": objectTypes.Sprite,
                         "interactive": true,
                         "uiMode": "desktop",
                         "layout": false,
                         "x": 1436,
                         "y": 372,
                         "width": 230,
                         "height": 83,
                         "text": "option4",
                         "textStyle": {
                             fontFamily: 'Oswald-Light',
                             fontSize: 24,
                             fontStyle: 'normal',
 
                             fill: ['#ffffff'],
                         },
                         "anchor": [0.5, 0.5],
                         "visible": true,
                         "buttonMode": true,
                         "buttonState": {
                             up: 'land_autoplay_btn_deselected.png',
                             out: 'land_autoplay_btn_deselected.png',
                             down: 'land_autoplay_btn_deselected.png',
                             disable: 'land_autoplay_btn_deselected.png',
                             enable: 'land_autoplay_btn_deselected.png',
                             hover: 'land_autoplay_btn_deselected.png'
                         },
                         "hitareaVisible": false,
                         "shapeVisible": false,
                         "shape": {}
                     },
                     {
                         "id": "singleWinLimitBtn5",
                         "name": "singleWinLimitBtn5",
                         "type": objectTypes.Sprite,
                         "interactive": true,
                         "uiMode": "desktop",
                         "layout": false,
                         "x": 1703,
                         "y": 372,
                         "width": 230,
                         "height": 83,
                         "text": "option5",
                         "textStyle": {
                             fontFamily: 'Oswald-Light',
                             fontSize: 24,
                             fontStyle: 'normal',
 
                             fill: ['#ffffff'],
                         },
                         "anchor": [0.5, 0.5],
                         "visible": true,
                         "buttonMode": true,
                         "buttonState": {
                             up: 'land_autoplay_btn_deselected.png',
                             out: 'land_autoplay_btn_deselected.png',
                             down: 'land_autoplay_btn_deselected.png',
                             disable: 'land_autoplay_btn_deselected.png',
                             enable: 'land_autoplay_btn_deselected.png',
                             hover: 'land_autoplay_btn_deselected.png'
                         },
                         "hitareaVisible": false,
                         "shapeVisible": false,
                         "shape": {}
                     },
                 ]
             }, */


            {
                "id": "stopAutoplayText",
                "name": "stopAutoplayText",
                "type": "Text",
                "x": 513,
                "y": 400,
                "width": 500,
                "height": 400,
                "visible": false,
                "layout": true,
                "uimode": "mobile",
                "text": "autoplayText_2",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 46,
                    fill: '#ffffff',
                },
            },
            /*  {
                 "id": "onAnyWinText",
                 "name": "onAnyWinText",
                 "type": "Text",
                 "x": 115,
                 "y": 897,
                 "width": 400,
                 "height": 400,
                 "visible": true,
                 "layout": true,
                 "uimode": "mobile",
                 "text": "stopOnWinText",
                 "scaleToFit": true,
                 "anchor": [0, 0.5],
                 "textStyle": {
                     fontFamily: 'Oswald-Light',
                     fontSize: 22,
                     fontStyle: 'normal',
                     fill: ['#848484'],
                 },
             },
 
             {
                 "id": "radioButtonOnAnyWin_Portrait",
                 "name": "radioButtonOnAnyWin_Portrait",
                 "type": objectTypes.Sprite,
                 "interactive": true,
                 "width": 101,
                 "height": 56,
                 "x": 1344,
                 "y": 895,
                 "text": "",
                 "layout": true,
                 "uimode": "mobile",
                 "anchor": [0.5, 0.5],
                 "visible": true,
                 "buttonMode": true,
                 "buttonState": {
                     up: 'land_radio_btn_on.png',
                     out: 'land_radio_btn_on.png',
                     down: 'land_radio_btn_on.png',
                     disable: 'land_radio_btn_on.png',
                     enable: 'land_radio_btn_on.png',
                     hover: 'land_radio_btn_on.png'
                 },
                 "hitareaVisible": false,
                 "shapeVisible": false,
                 "shape": {}
             },
             {
                 "id": "radioButtonOffOnAnyWin_Portrait",
                 "name": "radioButtonOffOnAnyWin_Portrait",
                 "type": objectTypes.Sprite,
                 "interactive": true,
                 "width": 101,
                 "height": 56,
                 "x": 1344,
                 "y": 895,
                 "text": "",
                 "layout": true,
                 "uimode": "mobile",
                 "anchor": [0.5, 0.5],
                 "visible": true,
                 "buttonMode": true,
                 "buttonState": {
                     up: 'land_radio_btn_off.png',
                     out: 'land_radio_btn_off.png',
                     down: 'land_radio_btn_off.png',
                     disable: 'land_radio_btn_off.png',
                     enable: 'land_radio_btn_off.png',
                     hover: 'land_radio_btn_off.png'
                 },
                 "hitareaVisible": false,
                 "shapeVisible": false,
                 "shape": {}
             },
 
             {
                 "id": "onFeatureTriggeredText",
                 "name": "onFeatureTriggeredText",
                 "type": "Text",
                 "x": 115,
                 "y": 797,
                 "width": 400,
                 "height": 400,
                 "visible": true,
                 "layout": true,
                 "uimode": "mobile",
                 "text": "stopfeaturetriggeredText",
                 "scaleToFit": true,
                 "anchor": [0, 0.5],
                 "textStyle": {
                     fontFamily: 'Oswald-Light',
                     fontSize: 22,
                     fontStyle: 'normal',
                     fill: ['#848484'],
                 },
             },
 
             {
                 "id": "radioButtonOnOnFeature_Portrait",
                 "name": "radioButtonOnOnFeature_Portrait",
                 "type": objectTypes.Sprite,
                 "interactive": true,
                 "width": 101,
                 "height": 56,
                 "x": 1344,
                 "y": 802,
                 "text": "",
                 "layout": true,
                 "uimode": "mobile",
                 "anchor": [0.5, 0.5],
                 "visible": true,
                 "buttonMode": true,
                 "buttonState": {
                     up: 'land_radio_btn_on.png',
                     out: 'land_radio_btn_on.png',
                     down: 'land_radio_btn_on.png',
                     disable: 'land_radio_btn_on.png',
                     enable: 'land_radio_btn_on.png',
                     hover: 'land_radio_btn_on.png'
                 },
                 "hitareaVisible": false,
                 "shapeVisible": false,
                 "shape": {}
             },
 
 
             {
                 "id": "radioButtonOffOnFeature_Portrait",
                 "name": "radioButtonOffOnFeature_Portrait",
                 "type": objectTypes.Sprite,
                 "interactive": true,
                 "width": 101,
                 "height": 56,
                 "x": 1344,
                 "y": 802,
                 "text": "",
                 "layout": true,
                 "uimode": "mobile",
                 "anchor": [0.5, 0.5],
                 "visible": true,
                 "buttonMode": true,
                 "buttonState": {
                     up: 'land_radio_btn_off.png',
                     out: 'land_radio_btn_off.png',
                     down: 'land_radio_btn_off.png',
                     disable: 'land_radio_btn_off.png',
                     enable: 'land_radio_btn_off.png',
                     hover: 'land_radio_btn_off.png'
                 },
                 "hitareaVisible": false,
                 "shapeVisible": false,
                 "shape": {}
             },
  */

            /*         {
                        "name": "inputBox_1",
                        "image": "meterImage",
                        "type": "Image",
                        "class": "",
                        "filterTypes": [],
                        "visible": false,
                        "width": 251,
                        "height": 67,
                        "x": 1230,
                        "y": 376
                    },
                    {
                        "name": "inputBox_2",
                        "image": "meterImage",
                        "type": "Image",
                        "class": "",
                        "filterTypes": [],
                        "visible": false,
                        "width": 251,
                        "height": 67,
                        "x": 1230,
                        "y": 494,
                    },
                    {
                        "name": "inputBox_3",
                        "image": "meterImage",
                        "type": "Image",
                        "class": "",
                        "filterTypes": [],
                        "visible": false,
                        "width": 251,
                        "height": 67,
                        "x": 1230,
                        "y": 612
                    }, */


            {
                "id": "sliderDot_2_inputBoxText",
                "name": "sliderDot_2_inputBoxText",
                "type": "Text",
                "x": 695,
                "y": 458,
                "width": 400,
                "height": 400,
                "visible": true,
                "text": "",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 24,

                    fill: '#ffffff',
                },
            },

            {
                "id": "sliderDot_3_inputBoxText",
                "name": "sliderDot_3_inputBoxText",
                "type": "Text",
                "x": 725,
                "y": 628,
                "width": 400,
                "height": 400,
                "visible": true,
                "text": "",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 24,

                    fill: '#ffffff',
                },
            },
            {
                "id": "sliderLineBG",
                "name": "sliderLineBG",
                "type": objectTypes.Sprite,
                "interactive": true,
                "width": 743,
                "height": 18,
                "x": 400,
                "y": 405,
                "text": "",
                "visible": false,
                "buttonMode": true,
                "buttonState": {
                    up: 'slider_base.png',
                    out: 'slider_base.png',
                    down: 'slider_base.png',
                    disable: 'slider_base.png',
                    enable: 'slider_base.png',
                    hover: 'slider_base.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },

            {
                "name": "sliderDot",
                "image": "sliderDot",
                "type": "Image",
                "class": "",
                "filterTypes": [],
                "visible": false,
                "width": 34,
                "height": 34,
                "x": 100,
                "y": 398
            },
            {
                "id": "sliderLine_2BG",
                "name": "sliderLine_2BG",
                "type": objectTypes.Sprite,
                "interactive": true,
                "width": 743,
                "height": 18,
                "x": 400,
                "y": 521,
                "text": "",
                "visible": false,
                "buttonMode": true,
                "buttonState": {
                    up: 'slider_base.png',
                    out: 'slider_base.png',
                    down: 'slider_base.png',
                    disable: 'slider_base.png',
                    enable: 'slider_base.png',
                    hover: 'slider_base.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },

            {
                "name": "sliderDot_2",
                "image": "sliderDot",
                "type": "Image",
                "class": "",
                "filterTypes": [],
                "visible": false,
                "width": 34,
                "height": 34,
                "x": 400,
                "y": 514
            },
            {
                "id": "sliderLine_3BG",
                "name": "sliderLine_3BG",
                "type": objectTypes.Sprite,
                "interactive": true,
                "width": 743,
                "height": 18,
                "x": 400,
                "y": 636,
                "text": "",
                "visible": false,
                "buttonMode": true,
                "buttonState": {
                    up: 'slider_base.png',
                    out: 'slider_base.png',
                    down: 'slider_base.png',
                    disable: 'slider_base.png',
                    enable: 'slider_base.png',
                    hover: 'slider_base.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },


            {
                "name": "sliderDot_3",
                "image": "sliderDot",
                "type": "Image",
                "class": "",
                "filterTypes": [],
                "visible": false,
                "width": 34,
                "height": 34,
                "x": 400,
                "y": 630
            },


            {
                "id": "ifSingleWinExceedText",
                "name": "ifSingleWinExceedText",
                "type": "Text",
                "x": 596,
                "y": 452,
                "width": 400,
                "height": 400,
                "visible": false,
                "text": "autoplayText_6",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 32,
                    fill: '#ffffff',
                },
            },
            {
                "id": "ifBalanceIncreaseByText",
                "name": "ifBalanceIncreaseByText",
                "type": "Text",
                "x": 601,
                "y": 571,
                "width": 400,
                "height": 400,
                "visible": false,
                "text": "autoplayText_7",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 32,
                    fill: '#ffffff',
                },
            },
            {
                "id": "ifBalanceDecreaseByText",
                "name": "ifBalanceDecreaseByText",
                "type": "Text",
                "x": 601,
                "y": 675,
                "width": 400,
                "height": 400,
                "visible": false,
                "text": "autoplayText_8",
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 32,
                    fill: '#ffffff',
                },
            },
            //  {
            //      "id": "Button_1",
            //      "name": "autoplay_StartButton",
            //      "type": objectTypes.Sprite,
            //      "interactive": false,
            //      "x": 1684,
            //      "y": 964,
            //      "height": 80,
            //      "width": 80,
            //      "text": "",
            //      "visible": true,
            //      "buttonState": {
            //          up: 'autoplay_down.png',
            //          out: 'autoplay_down.png',
            //          down: 'autoplay_down.png',
            //          disable: 'autoplay_down.png',
            //          enable: 'autoplay_down.png',
            //          hover: 'autoplay_down.png'
            //      },
            //      "hitareaVisible": false,
            //      "shapeVisible": false,
            //      "shape": {}
            //  },
            // {
            //     "id": "Button_2",
            //     "name": "autoplay_CancelButton",
            //     "type": objectTypes.Sprite,
            //     "interactive": true,
            //     "x": 1540,
            //     "y": 65,
            //     "height": 30,
            //     "width": 29,
            //     "text": "",
            //     "visible": true,
            //     "buttonMode": true,
            //     "buttonState": {
            //         up: 'autoplay_closed_up.png',
            //         out: 'autoplay_closed_up.png',
            //         down: 'autoplay_closed_down.png',
            //         disable: 'autoplay_closed_up.png',
            //         enable: 'autoplay_closed_up.png',
            //         hover: 'autoplay_closed_up.png'
            //     },
            //     "hitareaVisible": false,
            //     "shapeVisible": false,
            //     "shape": {}
            // },
            // {
            //     "id": "text_1",
            //     "name": "autoplay_text_start_label",
            //     "type": "Text",
            //     "x": 1055,
            //     "y": 778,
            //     "visible": false,
            //     "text": "autoplayText_20",
            //     "scaleToFit": true,
            //     "width": 210,
            //     "anchor": [0.5, 0.5],
            //     "textStyle": {
            //         fontFamily: 'Oswald-Light',
            //         fontSize: 26,

            //         fill: ['#ffffff', '#ffffff', '#ffffff'],
            //     },
            //     "parentLayer": "specialAnimationLayer",
            // },
            // {
            //     "id": "text_2",
            //     "name": "autoplay_text_cancel_label",
            //     "type": "Text",
            //     "x": 866,
            //     "y": 778,
            //     "visible": false,
            //     "text": "autoplayText_21",
            //     "scaleToFit": true,
            //     "anchor": [0.5, 0.5],
            //     "textStyle": {
            //         fontFamily: 'Oswald-Light',
            //         fontSize: 26,

            //         fill: ['#ffffff', '#ffffff', '#ffffff'],
            //     },
            //     "parentLayer": "specialAnimationLayer",
            // },


            {
                "id": "Button_M14",
                "name": "autoplay_StartButtonStroke",
                "type": objectTypes.Sprite,
                "interactive": true,
                "layout": true,
                "uimode": "mobile",
                "x": 1604,
                "y": 357,
                "width": 302,
                "height": 257,
                "text": "",
                "visible": true,
                "buttonMode": true,
                "buttonState": {
                    up: 'land_spinstroke_up.png',
                    out: 'land_spinstroke_up.png',
                    down: 'land_spinstroke_up.png',
                    disable: 'land_spinstroke_disable.png',
                    enable: 'land_spinstroke_up.png',
                    hover: 'land_spinstroke_up.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },

            {
                "id": "Button_M2",
                "name": "autoplay_StartButton",
                "type": objectTypes.Sprite,
                "interactive": true,
                "layout": true,
                "uimode": "mobile",
                "x": 1604,
                "y": 357,
                "width": 225,
                "height": 225,
                "text": "",
                "visible": true,
                "buttonMode": true,
                "buttonState": {
                    up: 'land_spin_up.png',
                    out: 'land_spin_up.png',
                    down: 'land_spin_up.png',
                    disable: 'land_spin_disable.png',
                    enable: 'land_spin_up.png',
                    hover: 'land_spin_up.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },

            //  {
            //      "id": "Button_M2",
            //      "name": "autoplay_StartButton",
            //      "type": objectTypes.Sprite,
            //      "interactive": true,
            //      "layout": true,
            //      "uimode": "mobile",
            //      "x": 1604,
            //      "y": 357,
            //      "width": 302,
            //      "height": 257,
            //      "text": "",
            //      "visible": true,
            //      "buttonMode": true,
            //      "buttonState": {
            //          up: 'land_spin_frame.png',
            //          out: 'land_spin_frame.png',
            //          down: 'land_spin_frame.png',
            //          disable: 'land_spin_frame.png',
            //          enable: 'land_spin_frame.png',
            //          hover: 'land_spin_frame.png'
            //      },
            //      "hitareaVisible": false,
            //      "shapeVisible": false,
            //      "shape": {}
            //  },


            {
                "id": "Button_M3",
                "name": "autoplay_CancelButton",
                "type": objectTypes.Sprite,
                "interactive": true,
                "layout": true,
                "uimode": "mobile",
                "x": 1613,
                "y": 466,
                "height": 31,
                "width": 32,
                "text": "",
                "visible": true,
                "buttonMode": true,
                "buttonState": {
                    up: 'land_autoplay_open_up.png',
                    out: 'land_autoplay_open_up.png',
                    down: 'land_autoplay_open_up.png',
                    disable: 'land_autoplay_open_up.png',
                    enable: 'land_autoplay_open_up.png',
                    hover: 'land_autoplay_open_up.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },



            {
                "name": "increaseBackPanel",
                "image": "land_base_btn.png",
                "type": objectTypes.Sprite,
                "layout": true,
                "uimode": "mobile",
                "visible": true,
                "x": 1702,
                "y": 220,
                "height": 126,
                "width": 126,
            },





            {
                "name": "decreaseBackPanel",
                "image": "land_base_btn.png",
                "type": objectTypes.Sprite,
                "layout": true,
                "uimode": "mobile",
                "visible": true,
                "x": 1702,
                "y": 621,
                "height": 126,
                "width": 126,
            },






            {
                "id": "Button_M4",
                "name": "autoplayCount_increases",
                "type": objectTypes.Sprite,
                "buttonMode": true,
                "layout": true,
                "uimode": "mobile",
                "interactive": true,
                "x": 1744,
                "y": 262,
                "height": 45,
                "width": 45,
                "text": "",
                "visible": true,
                "buttonState": {
                    up: 'plus_up.png',
                    out: 'plus_up.png',
                    down: 'plus_up.png',
                    disable: 'plus_disable.png',
                    enable: 'plus_up.png',
                    hover: 'plus_over.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },



            {
                "id": "Button_M5",
                "name": "autoplayCount_decreases",
                "type": objectTypes.Sprite,
                "buttonMode": true,
                "uimode": "mobile",
                "interactive": true,
                "layout": true,
                "x": 1744,
                "y": 666,
                "height": 45,
                "width": 45,
                "text": "",
                "visible": true,
                "buttonState": {
                    up: 'minus_up.png',
                    out: 'minus_up.png',
                    down: 'minus_up.png',
                    disable: 'minus_disable.png',
                    enable: 'minus_up.png',
                    hover: 'minus_over.png'
                },
                "hitareaVisible": false,
                "shapeVisible": false,
                "shape": {}
            },




            {
                "id": "text_4",
                "name": "autoplay_count",
                "type": "Text",
                "x": 1776,
                "y": 490,
                "visible": true,
                "uimode": "mobile",
                "layout": true,
                "text": "88",
                "width": 200,
                "scaleToFit": true,
                "anchor": [0.5, 0.5],
                "textStyle": {
                    fontFamily: 'Oswald-Light',
                    fontSize: 46,
                    fontWeight: 'bold',
                    fill: ['#ffffff', '#ffffff', '#ffffff'],
                },
                "parentLayer": "specialAnimationLayer",
            },
        ],
    }
};

export const CanvasAutoplayForMobileConfigurationContext = React.createContext(
    {}
);